import classes from "./index.module.scss";

export default function Card({ images, title, text }) {
  return (
    <li className={classes.card}>
      <picture>
        <source srcSet={images.webp} type="image/webp" />
        <img src={images.png} alt="University" width={1370} height={1002} />
      </picture>
      <div className={classes.card__content}>
        <h3 className={classes.card__title}>{title}</h3>
        <p className={classes.card__text}>{text}</p>
      </div>
    </li>
  );
}
